import type { CurrentUserResponse } from "@multi-chat/shared";

/** Narrow in-place name patch so Settings save does not re-bootstrap auth. */
export function applyOrganizationNameToUser(
  user: CurrentUserResponse,
  organizationId: number,
  name: string,
): CurrentUserResponse {
  return {
    ...user,
    organizations: user.organizations.map((organization) =>
      organization.id === organizationId ? { ...organization, name } : organization,
    ),
  };
}
